<template>
  <div class="page">
    <TopBack :title="$t('lang.wagering.title')"/>
    <div class="title">
      <span>{{ $t('lang.wagering.promptAll') }}</span>
    </div>
    <div class="list-wrapper">
      <div class="list-item item-header">
        <div class="name">
          <span>{{ $t('lang.wagering.name') }}</span>
        </div>
        <div class="provider">
          <span>{{ $t('lang.wagering.provider') }}</span>
        </div>
        <div class="wagering">
          <span>{{ $t('lang.wagering.wagering') }}</span>
        </div>
      </div>
      <div  class="list-item"
            v-for="(item, index) in gamesWagering"
            :key="index" v-if="item.Wagering > 0">
        <div class="name">
          <span>{{item.Name}}</span>
        </div>
        <div class="provider">
          <span>{{item.Provider}}</span>
        </div>
        <div class="wagering">
          <span>{{item.Wagering}}X</span>
        </div>
      </div>
    </div>
    <div class="title">
      <span>{{ $t('lang.wagering.promptFollowing') }}</span>
    </div>
    <div class="list-wrapper">
      <div  class="list-item"
            v-for="(item, index) in gamesWagering"
            :key="index" v-if="item.Wagering == 0">
        <div class="name">
          <span>{{item.Name}}</span>
        </div>
        <div class="provider">
          <span>{{item.Provider}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopBack from '@/components/TopBack/index'
import request from '@/service'

export default {
  name: 'wagering',
  components: {
    TopBack
  },
  data () {
    return {
      gamesWagering: []
    }
  },
  mounted () {
    this.getGamesWagering()
  },
  methods: {
    getGamesWagering: function () {
      const url = '/innovation/game/getgamewagering'
      const data = {
      }
      request('post', url, data).then(res => {
        this.gamesWagering = res.GamesWageringList
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .page {
    padding: 30px 16px 100px 16px;
    color: #FFFFFF;

    .title {
      font-size: 14px;
      margin: 15px 0px;
      color: #f6d9aa;
    }

    .list-wrapper {
      .item-header {
        font-size: 14px;
        font-weight: bold;
        color: #f6d9aa;
      }

      .list-item {
        display: flex;
        font-size: 12px;
        line-height: 20px;
        border-bottom: #686868 solid 1px;

        .name {
          white-space: nowrap;
          overflow: hidden;
          flex: 2;
          margin-right: 5px;
        }

        .provider {
          white-space: nowrap;
          overflow: hidden;
          flex: 2;
        }

        .wagering {
          white-space: nowrap;
          flex: 1;
          text-align: center;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Games/wagering.vue